import { t } from "@redotech/redo-i18n";

export function manualLabelInstructionsDefault(): string[] {
  return [
    t(
      "The product your returning requires a manual label to be generated, our team has been notified.",
    ),
    t("Please look out for an email from us with instructions."),
  ];
}

export function formLabelInstructionsDefault(): string[] {
  return [
    "Pack your items securely in a box or bag.",
    "Show the QR code below at your nearest {{carrier}} drop-off location. The carrier will scan it and print a label for you — you do not need to print anything.",
    "Keep your drop-off receipt as proof of return.",
  ];
}

export function australiaPostPrinterlessDefault(): string {
  return "Print your label, or skip printing: show this label on your phone at a participating Australia Post location and they will scan it for you.";
}
